import { FC } from 'react';
import styles from './DashboardSolicitationCard.module.css';
import PrimaryButton from '@/components/ui/shared/Button/PrimaryButton/PrimaryButton';
import SecondaryButton from '@/components/ui/shared/Button/SecondaryButton/SecondaryButton';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { openDialog } from '@/redux/slices/pageSlice';
import { cn } from '@/lib/utils';
import { FileEditIcon } from 'lucide-react';
import FileUploadIcon from '@/components/ui/icons/FileUploadIcon';
import { Variants, motion } from 'framer-motion';

interface DashboardSolicitationCardProps {
	animationStart?: (startTime) => Variants;
}

const DashboardSolicitationCard: FC<DashboardSolicitationCardProps> = ({
	animationStart,
}) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	return (
		<motion.div
			className={cn(
				styles.card,
				'flex flex-col 2xl:flex-row 2xl:items-center 2xl:justify-between gap-4 shadow-main'
			)}
			variants={animationStart && animationStart(0.2)}
			initial="initial"
			animate="animate"
			exit="exit"
		>
			<div>
				<h1 className="font-bold text-black dynamic-xl-large">
					Start New Proposal
				</h1>
				<p className="text-black">
					Click on the type of solicitation to start a new proposal.
				</p>
			</div>
			<div className="grid grid-cols-2 gap-4">
				<PrimaryButton
					className="solicitation-button"
					onClick={() => {
						navigate('/solicitations');
						dispatch(openDialog({ type: 'uploadSolicitation' }));
					}}
				>
					<FileUploadIcon />
					START SOLICITED PROPOSAL
				</PrimaryButton>
				<SecondaryButton
					className="unsolicitation-button"
					onClick={() => {
						navigate('/solicitations');
						dispatch(openDialog({ type: 'manualSolicitation' }));
					}}
				>
					<FileEditIcon />
					START UNSOLICITED PROPOSAL
				</SecondaryButton>
			</div>
		</motion.div>
	);
};

export default DashboardSolicitationCard;
